<template>
	<div class="text-right">
		<ul class="nav clearfix">
			<li v-if="planTime !== null">
				<span class="el-dropdown-link dropdown-padding" @click="$router.push({ name: 'alarmNotify', query: { notice_accounts: $store.getters.account.name } })">
					<a>
						<i class="icon-14 fa fa-envelope-open"></i>
						<translate>Alarm</translate>
						<span class="link-num" v-if="$store.getters.logs.alarmNotifyUnreadCounts"> {{ $store.getters.logs.alarmNotifyUnreadCounts }} </span>
					</a>
				</span>
			</li>
			<li v-if="planTime !== null">
				<span class="el-dropdown-link dropdown-padding" @click="showConnectList">
					<a>
						<i class="icon-14 fa fa-link"></i>
						<translate>Online Sessions</translate>
						<span class="link-num" v-if="currentConnectCount"> {{ currentConnectCount }} </span>
					</a>
				</span>
			</li>
			<li v-if="$language.current === 'zh_CN'">
				<a class="dropdown-padding" href="https://mrdoc.cloudcare.cn/doc/261/" target="_blank">
					<i class="icon-14 material-icons">help_outline</i>
					<translate>Help</translate>
				</a>
			</li>
			<li v-if="planTime !== null && $language.current === 'zh_CN'">
				<el-dropdown trigger="click">
					<span class="dropdown-padding">
						<i class="icon-14 material-icons">group</i>
						<a>
							<translate>Contact US</translate>
						</a>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<p>
								<translate>Customer Service</translate>:
								<a class="wang-item btn" target="_blank" href="https://work.weixin.qq.com/kfid/kfc63de878415ef9ba5"> <translate tag="span">Immediate Consultation</translate> </a>
							</p>
						</el-dropdown-item>
						<el-dropdown-item>
							<p><translate>Contact Number</translate>: <span>021-50653160</span></p>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<li v-if="planTime !== null">
				<el-dropdown @command="onSelectLanguage" trigger="click">
					<a class="el-dropdown-link dropdown-padding">
						<i class="fa fa-globe fa-lg"></i>
						<span>{{ $language.current === 'zh_CN' ? '简体中文' : 'English' }}</span>
					</a>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="en_US">English</el-dropdown-item>
						<el-dropdown-item command="zh_CN"> 简体中文 </el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<li>
				<el-tooltip placement="bottom" effect="light">
					<div slot="content">
						<span>套餐到期时间：</span>
						<span>{{ memberExpireTime.text }}</span>
					</div>
					<a class="el-dropdown-link dropdown-padding" :class="memberExpireTime.isExpire || memberExpireTime.matured ? 'isExpire' : ''">
						<i class="fa fa-id-card-o"></i>
						<span>{{ packageInfo.current_plan ? packageInfo.current_plan.name : '' }}</span>
						<span v-if="memberExpireTime.isExpire">（即将到期）</span>
						<span v-if="memberExpireTime.matured">（已到期）</span>
					</a>
				</el-tooltip>
			</li>
			<li>
				<el-dropdown trigger="click" @command="handleClickMenu">
					<span class="el-dropdown-link dropdown-padding">
						<a class="photo clearfix">
							<img :src="account.avatar | resetURL" border="0" />
							<span>{{ account.name }}</span>
						</a>
						<i class="el-icon-caret-bottom el-icon--right caret-download"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="logout">
							<translate>Logout</translate>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<li v-if="account.unique_id">
				<a id="widget-notify-list" class="dropdown-padding">
					<i class="fa fa-list-ul"></i>
				</a>
			</li>
		</ul>
		<!-- 在线用户弹出框 -->
		<el-dialog :title="attrText.onlineSessions" custom-class="onlineUserDialiog" :visible.sync="connectListDialogVisible" style="text-align: left">
			<div class="add-ssk">
				<el-button @click="cutOnline(batchDel)" :disabled="!batchDel.length">
					<translate>Disconnect</translate>
				</el-button>
			</div>
			<el-table stripe :data="currentConnectList" :empty-text="attrText.noSession" @selection-change="selectMultiple" v-loading="loading">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column width="80" prop="account.name" :label="attrText.member">
					<template scope="scope">
						{{ !scope.row.account ? '' : scope.row.account.name }}
					</template>
				</el-table-column>
				<el-table-column width="50" label=" ">
					<template scope="scope">
						<el-tooltip class="item" effect="dark" :content="attrText.unsafeMode" placement="top" v-if="!scope.row.safe_mode">
							<i class="fa fa-exclamation-circle warn"></i>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="resource_name" :label="attrText.resource"> </el-table-column>
				<el-table-column prop="resource_ip_address" :label="attrText.resourceIp"> </el-table-column>
				<el-table-column prop="way" :label="attrText.resourceWay">
					<template scope="scope">
						<span>{{ resourceWayMap[scope.row.way] }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="project_name" :label="attrText.workgroup"> </el-table-column>
				<el-table-column prop="createTime" :label="attrText.updateTime">
					<template scope="scope">
						{{ scope.row.createTime ? scope.row.createTime : '' }}
					</template>
				</el-table-column>
				<el-table-column :label="attrText.action">
					<template scope="scope">
						<el-button :disabled="!scope.row.linkHref || !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp))" @click="onLinkhref(scope.row.linkHref)" type="text" v-if="scope.row.agentVersion < '3.0.0'" target="_blank">
							<translate>Monitor</translate>
						</el-button>
						<el-button :disabled="!(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp))" type="text" v-if="scope.row.agentVersion >= '3.0.0'" target="_blank">
							<span v-if="scope.row.way === 'terminal' || scope.row.way === 'wetty'" @click="createShadow(scope.row)"><translate>assistance</translate></span>
							<span v-if="scope.row.way === 'rdp' && scope.row.showRdp" @click="onLinkhref(scope.row.linkHref)"><translate>monitor</translate></span>
						</el-button>
						<el-button type="text" @click="cutOnline([scope.row.id])"><translate>Disconnect</translate></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="currentConnectCount > 10">
				<el-pagination layout="total, prev, pager, next" :total="currentConnectCount" :page-size="10" :current-page.sync="currentConnectPage" @current-change="onChangePage"></el-pagination>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import STORE_CONST from '../store/consts'
import { baseUrl } from '../config'
import account from '../api/account'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import $ from 'jquery'
import Utility from '../Utils'
import Base64 from 'js-base64'
import moment from 'moment'
import Polling from '../plugins/polling'

window.jQuery = $

export default {
	props: ['packageInfo'],
	name: 'Header',
	data() {
		return {
			connectList: [],
			workgroupIds: [],
			workgroupList: {},
			planTime: 0,
			batchDel: [],
			connectListDialogVisible: false,
			currentConnectPage: 1,
			loading: false,
			resourceWayMap: {
				terminal: 'Linux',
				rdp: 'Windows',
				mysql: 'MySQL',
				mssql: 'SQL server',
				wetty: 'Wetty',
				postgresql: 'PostgreSQL',
				oracle: 'Oracle',
			},
			isExpire: false,
			matured: false,
			alarmNotifyNotice: false,
			pollingInstance: null, // 轮询实例
			isPolling: false, // 是否正在轮询
			isPaused: false, // 轮询是否暂停
		}
	},
	created() {
		this.getOnlineConnectsCounts()
		this.$store.dispatch(STORE_CONST.TEAM.CURRENT).then((res) => {
			this.planTime = res.current_plan
		})

		this.initPolling()
	},
	computed: {
		currentConnectList() {
			console.log('currentConnectList', this.$store.getters.dashboard.onlineMembers)
			return this.$store.getters.dashboard.onlineMembers
		},
		currentConnectCount() {
			return this.$store.getters.dashboard.onlineMembersCount
		},
		account() {
			let currentAccount = this.$store.getters.account
			return currentAccount
		},
		attrText() {
			return this.getText()
		},
		languageCurrent() {
			return this.$language.current
		},
		// 判断会员到期时间
		memberExpireTime() {
			const timestamp = this.packageInfo.expire
			if (!timestamp) {
				return { text: '暂无', remainingDays: 0, isExpire: false, matured: false }
			}
			const remainingDays = (timestamp - Date.now() / 1000) / 3600 / 24
			const isExpire = remainingDays > 0 && remainingDays <= 30
			const matured = remainingDays <= 0
			const text = moment(timestamp * 1000).format('YYYY-MM-DD')
			return { text, remainingDays, isExpire, matured }
		},
	},
	methods: {
		getText() {
			return {
				unsafeMode: this.$gettext('Unsafe Mode'),
				member: this.$gettext('Member'),
				workgroup: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				resourceIp: this.$gettext('Resource IP'),
				resourceWay: this.$gettext('Resource Way'),
				action: this.$gettext('Action'),
				noSession: this.$gettext('no online sessions'),
				onlineSessions: this.$gettext('Online Sessions'),
				updateTime: this.$gettext('Create Time'),
			}
		},
		onLinkhref(url) {
			if (url) {
				window.open(url)
			}
		},
		createShadow(con) {
			let params = {
				master_connection_id: con.connection_id,
				readonly: false,
				expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60,
			}
			var newWin = window.open('')
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_SHADOW, params).then(
				(res) => {
					let shadowUrl = `http://${res.agent_host}:${res.agent_webtty_port}/?code=${Base64.Base64.encode(res.code)}&user=${res.user}&team_name=${this.$store.getters.team.setting.full_name}&account_name=${this.$store.getters.account.name}`
					newWin.location.href = shadowUrl
				},
				() => {
					newWin.close()
				},
			)
		},
		// 在线用户分页改变
		onChangePage(pageIndex) {
			this.currentConnectPage = pageIndex
			this.getOnlineConnects(pageIndex)
		},
		// 多选
		selectMultiple(val) {
			this.batchDel = val.map((item) => item.id)
		},
		// 显示在线用户弹出框
		showConnectList() {
			this.getOnlineConnects()
			this.connectListDialogVisible = true
		},
		// 获取在线用户数量
		getOnlineConnectsCounts() {
			this.$store.dispatch(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS).then((res) => {})
		},
		// 获取在线用户列表
		getOnlineConnects(page) {
			this.currentConnectPage = page || 1
			this.loading = true
			const params = {
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, params).then((res) => {
				if (res && res.length) {
					let _connectList = Object.clone(res)
					_connectList.forEach((item, index) => {
						let linkHref = ''
						if (item.guacamole && item.guacamole === 1) {
							// gucamole 类型的rdp 监视
							linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + Base64.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name
						} else {
							// 旧的类型的rdp 以及 terminal 类型
							linkHref += 'playlog.html'
							linkHref += '?link=' + baseUrl.apiUrl
							linkHref += '&way=' + item.way
							linkHref += '&code=' + item.tunnel_code
							linkHref += '&lang=' + this.languageCurrent
							linkHref += '&type=monitor'
						}
						if (item.connection_id) {
							linkHref += '&connection_id=' + item.connection_id
						}
						item.linkHref = linkHref
						item.createTime = moment(item.create_time * 1000).format('YYYY-MM-DD HH:mm')
						let showRdp = false
						if (item.agent_version) {
							item.noResourceDisabled = false
							if (Utility.Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
								showRdp = true
							}
							item.agentVersion = Utility.Utils.getAgentVersion(item.agent_version)
						}
						item.showRdp = showRdp
					})
					this.connectList = _connectList
					this.loading = false
					console.log('connects------->+', this.connectList)
					this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, this.connectList)
				} else {
					this.loading = false
				}
			})
		},
		// 断开连接
		cutOnline(ids) {
			this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store
					.dispatch(STORE_CONST.DASHBOARD.CUT_ONLINE_MULTIPLE, { connection_ids: ids })
					.then(() => {
						let copy = Object.clone(this.$store.getters.dashboard.onlineMembers)
						let copyCount = Object.clone(this.$store.getters.dashboard.onlineMembersCount)
						ids.forEach((id) => {
							copy.forEach((item, key) => {
								if (item.id === id) {
									console.log('--id', id)
									copy.splice(key, 1)
								}
							})
						})
						this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, copy)
						this.getOnlineConnects()
						this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - ids.length)
						this.$notify({
							type: 'success',
							message: this.$gettext('Disconnect successfully!'),
						})
					})
					.catch((err) => {
						console.log('err', err)
					})
			})
		},
		// 切换语言
		onSelectLanguage(language) {
			localStorage.setItem('currentLanguage', language)
			this.$language.current = localStorage.getItem('currentLanguage')
			if (this.$language.current === 'en_US') {
				locale.use(en)
			} else {
				locale.use(zh)
			}
		},
		// 退出登录
		handleClickMenu(command) {
			if (command === 'logout') {
				// const isHomeUser = !!this.account.unique_id
				account.logout().then((res) => {
					this.$notify({
						message: this.$gettext('LoginOut successfully!'),
						type: 'success',
					})
					// if (isHomeUser) {
					//   window.location.href = baseUrl.ccLogout
					// } else {
					this.$router.push('/login')
					// }
				})
			}
		},

		// 获取最新未读告警通知数量
		async getAlarmNotifyUnreadCounts() {
			return this.$store.dispatch(STORE_CONST.LOG.GET_ALARM_NOTIFY_UNREAD_COUNTS).then((res) => {
				return res
			})
		},

		// 关闭告警通知
		closeAlarmNotify() {
			this.$store.dispatch(STORE_CONST.LOG.CLOSE_ALARM_NOTIFY).then((res) => {
				if (res && res.status) {
					this.alarmNotifyStatus = res.status
				}
			})
		},

		initPolling() {
			this.pollingInstance = new Polling({
				interval: 1000 * 10,
				maxRetry: 3,
				requestFn: this.getAlarmNotifyUnreadCounts,

				// 请求成功回调
				onSuccess: (result) => {
					this.isPolling = true
					this.isPaused = false
					console.log('轮询获取状态：', result)
					this.alarmNotifyNotice = result.notice
					this.$store.commit(STORE_CONST.LOG.UNREAD_COUNTS, result.num)
				},
				// 请求失败回调
				onError: (error) => {
					console.error('轮询请求失败：', error)
				},
				// 轮询完成/停止回调
				onComplete: () => {
					this.isPolling = false
					this.isPaused = false
					console.log('轮询已停止')
				},
			})
		},

		startPolling() {
			this.pollingInstance.start()
		},
	},
	mounted() {
		this.startPolling()
	},
	beforeDestroy() {
		// 组件销毁前停止轮询，避免内存泄漏
		if (this.pollingInstance) {
			this.pollingInstance.stop()
		}
	},
	watch: {
		$route(to, from) {
			this.getOnlineConnectsCounts()
		},
		languageCurrent: function (newVal, oldVal) {
			this.getOnlineConnectsCounts()
		},
		alarmNotifyNotice: function (newVal, oldVal) {
			if (newVal && newVal !== oldVal) {
				this.$notify({
					message: this.$gettext('You Have A New Alert Notification. Please Check It Promptly.'),
					type: 'warning',
					duration: 5 * 50 * 1000,
					offset: 50,
					onClick: () => {
						this.$router.push({ name: 'alarmNotify', query: { notice_accounts: this.$store.getters.account.name } })
					},
					onClose: () => {
						this.$store.dispatch(STORE_CONST.LOG.CLOSE_ALARM_NOTIFY)
					},
				})
			}
		},
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../assets/css/variable';
ul.nav {
	display: inline-block;
	> li {
		float: left;
		cursor: pointer;
		line-height: 60px;
		&:hover {
			background: #f5f5f5;
			a {
				color: $mainColor;
			}
		}
		a {
			color: $textColor;
		}
		i.icon-14 {
			font-size: 14px;
			position: relative;
			top: 2px;
		}
		&:first-of-type {
			i.icon-14 {
				top: 0;
			}
		}
		.caret-download {
			font-size: 12px;
		}
		.photo {
			display: inline-block;
			float: left;
			> img {
				width: 36px;
				height: 36px;
				-webkit-border-radius: 50%;
				-moz-border-radius: 50%;
				border-radius: 50%;
				margin: 12px 5px 12px 0;
				float: left;
			}
		}
		.isExpire {
			color: #f76164;
			&:hover {
				color: #f76164;
			}
		}
	}
}

.link-num {
	display: inline-block;
	line-height: 12px;
	background: #fea542;
	color: #fff;
	text-align: center;
	font-size: 12px;
	border-radius: 4px;
	padding: 3px 5px;
	margin-right: 4px;
}

.connect-account {
	min-width: 250px;
	padding: 10px 0;
	height: 60px;
	position: relative;
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border: 0;
		float: left;
	}
	.connect-content {
		padding: 0 80px 0 40px;
		line-height: 20px;
		.limit-name {
			display: inline-block;
			max-width: 300px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.item {
			color: red;
			vertical-align: super;
		}
	}
	.connect-action {
		line-height: 0px;
		a {
			color: $mainColor;
			&:hover {
				color: #69a0ff;
				cursor: pointer;
			}
		}
		a[disabled] {
			color: $textColor;
			&:hover {
				cursor: not-allowed;
			}
		}
	}
}
.dropdown-padding {
	padding: 0 10px;
	display: inline-block;
}

.el-dropdown-menu {
	max-height: 450px;
	overflow: auto;
	padding: 0;
	.el-dropdown {
		padding: 0 10px;
	}
	.wang-item.btn {
		color: $textColor;
		display: inline-block;
		text-align: center;
		height: 30px;
		line-height: 30px;
		width: 100px;
		margin: 10px 0;
		background-color: #20a0ff;
		color: #fff;
		border-radius: 5px;
		&:hover {
			background-color: #1a8be2;
		}
	}
	> .el-dropdown-menu__item:not(:first-child) {
		border-top: 1px solid #ddd;
	}
}

.onlineUserDialiog {
	.item {
		color: red;
		vertical-align: super;
	}
	width: 75% !important;
	height: 65%;
	overflow: hidden;
	text-align: left;
	.el-table th,
	.el-table td {
		text-align: left;
	}
	.el-dialog__body {
		height: 90%;
		.el-table {
			height: 75%;
			.el-table__body-wrapper {
				height: 85%;
				overflow-y: auto;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// header.vue?32a3182b